 export const generatePlaceAndTypeOfCareDropdown = () => {
    return [
        {
            'label': 'Betreuung in der Wohnung (WO)',
            'value': 'Betreuung in der Wohnung (WO)'
        },
        {
            'label': 'Betreuung mit Beginn und/oder Ende der Betreuung außerhalb der Wohnung (EX)',
            'value': 'Betreuung mit Beginn und/oder Ende der Betreuung außerhalb der Wohnung (EX)'
        },
        {
            'label': 'Telefonkontakt (TE)',
            'value': 'Telefonkontakt (TE)'
        }
    ]
 }